/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_Matrix_LeadInputs */

const en_cmp_matrix_lead = /** @type {(inputs: Cmp_Matrix_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every Bystep item here is live in the product today — not a roadmap promise. Competitor claims we couldn't verify first-hand are marked “as far as we know.”`)
};

const id_cmp_matrix_lead = /** @type {(inputs: Cmp_Matrix_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap item Bystep di sini sudah berjalan hari ini di produk — bukan janji roadmap. Klaim kompetitor yang tidak bisa kami verifikasi langsung ditandai "sepengetahuan kami."`)
};

/**
* | output |
* | --- |
* | "Every Bystep item here is live in the product today — not a roadmap promise. Competitor claims we couldn't verify first-hand are marked “as far as we know.”" |
*
* @param {Cmp_Matrix_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_matrix_lead = /** @type {((inputs?: Cmp_Matrix_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Matrix_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_matrix_lead(inputs)
	return en_cmp_matrix_lead(inputs)
});